import { PrimeReactProvider } from "primereact/api";
import { BrowserRouter } from "react-router-dom";
import ChatSidebar from "./components/ChatSidebar/ChatSidebar";
import Routes from "./Routes";

const App = () => {
  return (
    <PrimeReactProvider value={{ unstyled: true }}>
      <BrowserRouter>
        <ChatSidebar>
          <Routes />
        </ChatSidebar>
      </BrowserRouter>
    </PrimeReactProvider>
  );
};

export default App;
